import React from 'react';

import PropTypes from 'prop-types';

import { MoreHorizontalIcon } from '@adsk/alloy-react-icon';
import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

import Avatar from './Avatar';
import {
  AvatarSize,
  AVATAR_SIZES,
  AvatarGroupTruncation,
  AVATAR_GROUP_TRUNCATION,
  AVATAR_GROUP_MORE_ICON_SIZE,
} from './constants';

type AvatarGroupTruncationProps = StylableComponent<HTMLSpanElement> & {
  size: AvatarSize;
  truncation?: AvatarGroupTruncation;
  count: number;
};

const Truncation = React.forwardRef<
  HTMLSpanElement,
  AvatarGroupTruncationProps
>(({ style, className, truncation, size, count, onClick }, ref) => (
  <Avatar
    ref={ref}
    onClick={onClick}
    className={className}
    size={size}
    style={[
      {
        cursor: 'pointer',
        color: theme.tokens.colors.text.primary.value,
        backgroundColor:
          theme.tokens.colors.background.accent.six.subtler.value,
        ':hover': {
          color: theme.tokens.colors.icon.primary.value,
          backgroundColor: theme.tokens.colors.background.hover.value,
        },
      },
      style,
    ]}
  >
    {truncation === AVATAR_GROUP_TRUNCATION.NUMERIC && `+${count}`}
    {truncation === AVATAR_GROUP_TRUNCATION.DOTTED && (
      <MoreHorizontalIcon size={AVATAR_GROUP_MORE_ICON_SIZE[size]} />
    )}
  </Avatar>
));

Truncation.displayName = 'Truncation';

Truncation.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** count displayed for numeric truncation */
  count: PropTypes.number.isRequired,
  /** Set the size of the avatar */
  size: PropTypes.oneOf(Object.values(AVATAR_SIZES)).isRequired,
  /** Set the size of the avatar */
  truncation: PropTypes.oneOf(Object.values(AVATAR_GROUP_TRUNCATION)),
  /** Class applied to the root element */
  onClick: PropTypes.func,
};

export default Truncation;
